import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=1f9b3e80&scoped=true&lang=pug&"
import script from "./ModalBase.vue?vue&type=script&lang=js&"
export * from "./ModalBase.vue?vue&type=script&lang=js&"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=1f9b3e80&lang=scss&scoped=true&"
import style1 from "./ModalBase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b3e80",
  null
  
)

export default component.exports